import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import AppContext from "../../context/AppContext";
import Glyphicon from "../Glyphicon";
import Kraj from "../Kraj";
import { getButtonClassName } from "./functions";

class Kraje extends PureComponent {
  static contextType = AppContext;

  showAll = () => {
    const { showAllCountries } = this.context;
    showAllCountries();
  };

  hideAll = () => {
    const { hideAllCountries } = this.context;
    hideAllCountries();
  };

  render() {
    const { countries } = this.context;
    return (
      <div className="Kraje">
        <div className="Kraje_header">
          Kraje
          <button
            className={getButtonClassName("show", countries)}
            onClick={this.showAll}
            title="Pokaż z wszystkich krajów"
          >
            <Glyphicon icon="visibility" className="Kraje_icon" />
          </button>
          <button
            className={getButtonClassName("hide", countries)}
            onClick={this.hideAll}
            title="Ukryj z wszystkich krajów"
          >
            <Glyphicon icon="visibility_off" className="Kraje_icon" />
          </button>
        </div>
        <div className="Kraje_body">
          {countries
            .filter((country: any) => country.isAvailable)
            .sort((a: any, b: any) => {
              return a.name > b.name ? 1 : -1;
            })
            .map((country: any) => (
              <Kraj key={country.id} country={country} />
            ))}
        </div>
      </div>
    );
  }
}

export default Kraje;
